export const SET_DATA_FILTERS = 'dataFilters.SET_DATA_FILTERS';

export type SET_DATA_FILTERS = typeof SET_DATA_FILTERS;
